import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const CrownIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M2 14C2 13.4477 2.44772 13 3 13H13C13.5523 13 14 13.4477 14 14C14 14.5523 13.5523 15 13 15H3C2.44772 15 2 14.5523 2 14Z"
		/>
		<path
			fill="currentColor"
			d="M8.51114 3.06338C8.47487 2.9675 8.51855 2.86133 8.60048 2.79971C8.8431 2.61725 9 2.32695 9 2C9 1.44772 8.55228 1 8 1C7.44772 1 7 1.44772 7 2C7 2.32695 7.1569 2.61725 7.39952 2.79971C7.48145 2.86133 7.52513 2.9675 7.48886 3.06338L6.11568 6.69414C6.05347 6.85863 5.86375 6.93457 5.70522 6.85845L3.06223 5.5893C2.95752 5.53902 2.91959 5.41041 2.95435 5.29958C2.98401 5.205 3 5.10437 3 5C3 4.44772 2.55228 4 2 4C1.44772 4 1 4.44772 1 5C1 5.55228 1.44772 6 2 6C2.10906 6 2.21348 6.0674 2.23487 6.17435L3 10V11.5C3 11.7761 3.22386 12 3.5 12H12.5C12.7761 12 13 11.7761 13 11.5V10L13.7651 6.17435C13.7865 6.0674 13.8909 6 14 6C14.5523 6 15 5.55228 15 5C15 4.44772 14.5523 4 14 4C13.4477 4 13 4.44772 13 5C13 5.10437 13.016 5.205 13.0456 5.29958C13.0804 5.41041 13.0425 5.53902 12.9378 5.5893L10.2948 6.85845C10.1362 6.93457 9.94653 6.85863 9.88432 6.69414L8.51114 3.06338Z"
		/>
	</svg>
))
